import { Grid } from "@mui/material";
import MDBox from "components/MDBox";

import { Fieldset } from "ui-components/Form";
import { DatePickerField, Text } from "ui-components/Form";

function InvoiceHeader({ headerRender, control, errors }) {
  function renderFn(property, index, length) {
    const { size, disabled, editable, ...data } = property;
    const xs = 6/2
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
    };
    let renderField;
    switch (fieldProps.type) {
      case "text":
      case "number":
        renderField = <Text field={fieldProps} />;
        break;
      case "date":
        renderField = <DatePickerField field={fieldProps} />;
        break;
    }
    return (
      <Grid key={index} item xs={xs}>
        {renderField}
      </Grid>
    );
  }
  return (
    <MDBox>
      <MDBox mt={1.625}>
        {headerRender.map((rows, i) => {
          if (rows[0].type === "fieldset") {
            return (
              <Fieldset label={rows[0].label} key={i}>
                {rows[0].fieldsetRender.map((fs_rows, fs_i) => (
                  <Grid container spacing={3} key={fs_i}>
                    {fs_rows.map((fs_row, fs_index) => renderFn(fs_row, fs_index, fs_rows.length))}
                  </Grid>
                ))}
              </Fieldset>
            );
          }
          return (
            <Grid container spacing={3} key={i}>
              {rows.map((row, index) => renderFn(row, index, rows.length))}
            </Grid>
          );
        })}
      </MDBox>
    </MDBox>
  );
}

export default InvoiceHeader;
